import React from "react";

import LandingHeader from "pages/landing/includes/LandingHeader";
import LandingFooter from "pages/landing/includes/LandingFooter";

class KnowUs extends React.Component {

    render() {
        return (
            <>
                <LandingHeader />
                
                <div className="breadcrumb-area shadow dark bg-fixed text-center text-light" style={{"backgroundImage": "url(assets/edocom/img/banner/4.jpg)"}}>
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12 col-md-12">
                                <h1>Know Us</h1>
                                <ul className="breadcrumb">
                                    <li><a href="#/"><i className="fas fa-home"></i> Home</a></li>
                                    <li><a href="#/">About Us</a></li>
                                    <li className="active">Know Us</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="about-area default-padding">
                    <div className="container">
                        <div className="row">
                            <div className="about-items">
                                <div className="col-md-12 about-info">
                                    <h2>Welcome ! <span>We're an URL shortening service!</span></h2>
                                    <blockquote>
                                        With a goal to provide URL shortening to our users and link tracking to analyze the traffic the platform is being developed and started. This is developed by Shouvik Sarkar and we are having couple of more user based platforms along side this named Biznet (A professional networking platform) and Enroute (A news sharing platform for emerging people). This is though the first platform developed in Javascript (Node + React) by us. We are always extending our services in all our platforms and will also look to do the same for UShort by adding newer features every now and then to it. This is started in Feb 2025 and we will look to provide our services longer and free forever. Hope to see you using our services.
                                    </blockquote>
                                    <div className="semester-apply">
                                        <div className="row">
                                            <div className="col-md-6 col-sm-6 item">
                                                <h4>Register</h4>
                                                <p>
                                                    Want to try our service. Don't have an account yet?
                                                </p>
                                                <a className="btn btn-dark effect btn-sm" href="/signup"><i className="fas fa-angle-right"></i> Sign Up</a>
                                            </div>
                                            <div className="col-md-6 col-sm-6 item">
                                                <h4>Sign In</h4>
                                                <p>
                                                    Already loving our services. You are an existing user?
                                                </p>
                                                <a className="btn btn-dark effect btn-sm" href="/signin"><i className="fas fa-angle-right"></i> Sign In</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <LandingFooter />
            </>
        );
    }
}

export default KnowUs;
